import * as React from "react";
import { SVGProps } from "react";
function SvgSelectArrowIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41Z"
        fill="#000"
      />
    </svg>
  );
}
export default SvgSelectArrowIcon;
